import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Paper,
    TextField,
    Typography,
} from '@material-ui/core';
import { Close as CloseIcon, Lock as LockIcon, PlayCircleOutline as PlayArrowIcon } from '@material-ui/icons';
import arrayMove from 'array-move';
import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { DragSourceMonitor, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { Flipped, Flipper } from 'react-flip-toolkit';

import { getPlaylist, setPlaylist, Track } from './ApiManager';
import AuthContext from './AuthContext';
import { REACT_APP_EXPORT_PLAYLIST_URL } from './env'

// import { Track } from './ApiManager'
function EmptyDropZone({
    addTrack,
}: {
    addTrack: (track: Track, index?: number) => void,
}) {
    const [, ref] = useDrop({
        accept: 'album-track',
        drop: (item: any, monitor: DropTargetMonitor) => {
            addTrack(item.track)
        },
    })

    return <div ref={ref} style={{
        width: '100%',
        height: '40px',
        border: '3px dashed lightgrey',
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }}>
        Glissez-déposez une piste ici
    </div>
}

function formatDuration(duration: number) {
    const seconds = duration % 60
    const minutes = Math.floor((duration % 3600) / 60)
    const hours = Math.floor(duration / 3600)

    const secStr = seconds.toString().padStart(2, '0')
    const minStr = minutes.toString().padStart(2, '0')

    if (duration < 60)
        return `0:${secStr}`
    if (duration < 3600)
        return `${minutes}:${secStr}`
    return `${hours}:${minStr}:${secStr}`
}

function cleanPlaylistId(id: string) {
    const splited = id.split('-')
    return splited.length === 2 ? splited[1] : splited[0]
}

function TrackItem({ track, moveTrack, addTrack, delTrack, onClick, isOwner, flippedProps }: {
    track: IndexedTrack,
    isOwner: boolean,
    moveTrack: (track: IndexedTrack, index: number) => void,
    addTrack: (track: Track, index: number) => void,
    delTrack: (track: IndexedTrack) => void,
    onClick: () => void,
    flippedProps: any,
}) {
    const [hover, setHover] = useState(false)
    // const [tmpHover, setTmpHover] = useState(null)
    const [collectedProps, dropRef] = useDrop({
        // ref: myRef,
        accept: ['album-track', 'playlist-track'],
        drop: (droped: any, monitor: DropTargetMonitor) => {
            if (droped.type === 'album-track') {
                addTrack(droped.track, track.index)
            } else if (droped.type === 'playlist-track') {
                moveTrack(droped.track, track.index)
            }
            return droped
        },
        // hover: (item: any, monitor: DropTargetMonitor) => {
        //     if (item.track.index === track.index)
        //         return
    
        //     moveTrack(item.track, track.index)

        //     setTmpHover(item.track)
        // },
        collect: (monitor: DropTargetMonitor) => {
            return {
                hovered: monitor.isOver()
            }   
        },
    })
    const [collectedProps2, dragRef] = useDrag({
        // ref: ref,
        item: { barcode: track.barcode, track: track, type: 'playlist-track' },
        collect: (monitor: DragSourceMonitor) => {
            return {
                dragging: monitor.isDragging(),
            }
        }
    })
    // const hover = useHoverDirty(ref)
    const { hovered } = collectedProps
    const { dragging } = collectedProps2

    //console.log('COLLECTED PROPS', collectedProps)

    function onMouseOver() {
        setHover(true)
    }
    function onMouseLeave() {
        setHover(false)
    }

    return <div ref={isOwner ? dragRef : null} {...flippedProps}>
        <div ref={isOwner ? dropRef : null}
    style={{
        width: '100%',
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        marginBottom: 2,
        border: '1px solid transparent',
        borderTopColor: hovered ? 'darkgrey' : 'transparent',
        boxSizing: 'border-box',
        backgroundColor: dragging ? 'lightgrey' : 'transparent',
        cursor: 'pointer',
    }}
    onMouseOver={onMouseOver}
    onMouseLeave={onMouseLeave}
    onClick={onClick}>
        <div style={{position: 'relative'}}>
            <img src={track.cover_url} alt={track.title} style={{
                width: 40,
                height: 40,
                marginRight: 16,
                flexShrink: 0,
            }} />
            { hover
                ? [<div key={0} style={{
                    position: 'absolute',
                    top: 0,
                    width: 40,
                    height: 40,
                    backgroundColor: 'black',
                    opacity: 0.7,
                }} />, <PlayArrowIcon key={1} style={{
                    position: 'absolute',
                    color: 'white',
                    top: 0,
                    left: 0,
                    width: 32,
                    height: 32,
                    padding: 4,
                    // marginRight: 16,
                    // flexShrink: 0,
                }} />] : null
            }
        </div>
        {/* {
            hover
            ? <PlayArrowIcon style={{
                width: 32,
                height: 32,
                padding: 4,
                marginRight: 16,
                flexShrink: 0,
            }} />
            : (<img src={track.cover_url} style={{
                width: 40,
                height: 40,
                marginRight: 16,
                flexShrink: 0,
            }} />)
        } */}
        <Typography style={{
            flexGrow: 1,
            textOverflow: 'ellipsis',
            paddingRight: 16,
        }} align='left' noWrap={true}>
            {track.title}
        </Typography>
        {
            hover && isOwner
            ? <CloseIcon onClick={() => delTrack(track)} />
            : <Typography variant='caption'>
                {formatDuration(track.duration)}
            </Typography>
        }
        </div>
    </div>
}

type MedialistManagerProps = {
    userId: string | null
    isOwner: boolean,
    playlistId: string | null
    onRenamePlaylist: (name: string) => void
    onRemovePlaylist: () => void
}

interface IndexedTrack extends Track {
    index: number
}

interface PlaylistHistory {
    [userId: string]: {
        [playlistId: string]: {
            revisions: {
                tracks: IndexedTrack[]
            }[]
        }
    }
}

// const history = {} as PlaylistHistory

// function pushHistory(
//     userId: string,
//     playlistId: string,
//     name: string,
//     tracks: IndexedTrack[]) {
//     // let storedHistory = localStorage.getItem('history')
//     // let history = storedHistory
//     //     ? JSON.parse(storedHistory) as PlaylistHistory
//     //     : {}

//     if (!(history[userId]))
//         history[userId] = {}
//     if (!(history[userId][playlistId]))
//         history[userId][playlistId] = { revisions: [] }

//     const revisions = history[userId][playlistId].revisions
//     revisions.push({ tracks })
//     // localStorage.setItem('history', JSON.stringify(history))
//     // setPlaylist(userId!, playlistId!, name, tracks)
// }

// function popHistory(
//     userId: string,
//     playlistId: string,
//     name: string): IndexedTrack[] {
//     const history = localStorage.getItem('history') as unknown as PlaylistHistory
//     const revisions = history[userId][playlistId].revisions
//     const lastRevision = revisions.pop()
//     if (!lastRevision)
//         return []
//     // localStorage.setItem('history', JSON.stringify(history))
//     // setPlaylist(userId!, playlistId!, name, lastRevision.tracks)
//     return lastRevision.tracks
// }

// function isDescendant(parent: HTMLElement, child: HTMLElement) {
//     let node = child.parentNode;
//     while (node != null) {
//         console.log('node', node)
//         if (node === parent) {
//             return true;
//         }
//         node = node.parentNode;
//     }
//     return false;
// }

function MedialistManager({
    userId,
    isOwner,
    playlistId,
    onRenamePlaylist,
    onRemovePlaylist,
}: MedialistManagerProps) {

    const [name, setName] = useState('')
    const [tracks, setTracks] = useState([] as IndexedTrack[])
    // const [currentTrack, setCurrentTrack] = useState(-1)
    const { settings } = useContext(AuthContext)
    const mmePlayerRef = useRef(null as MMEEmbeddedPlayer | null)

    console.log('settings', settings)

    useEffect(() => {
        if (!userId || !playlistId)
            return
        getPlaylist(userId, playlistId).then(res => {
            setName(res.item.name)
            if (res.results) {
                const indexedTracks = [] as IndexedTrack[]
                console.log(res.results.tracks)

                for (let track of res.results.tracks) {
                    indexedTracks.push({
                        ...track,
                        index: res.results.tracks.indexOf(track),
                    })
                }
                const newTracks = indexedTracks //.sort(tr => tr.index)
                console.log(newTracks)

                setTracks(newTracks)
                // pushHistory(userId!, playlistId!, name, newTracks)
            } else {
                setTracks([])
                // pushHistory(userId!, playlistId!, name, [])
            }
        })
    }, [userId, playlistId])

    useEffect(() => {
        if (!mmePlayerRef || !mmePlayerRef.current) {
            return
        }
        mmePlayerRef.current.addEventListener('play', () => {
            const audios = document.getElementsByTagName('audio')
            for (var i = 0; i < audios.length; i++) {
                if (!audios[i].classList.contains('mme-player')) {
                    audios[i].pause()
                }
            }
        })
    // }, [mmePlayerRef.current])
    })

    const [openRenameDialog, setOpenRenameDialog] = useState(false)

    const moveTrack = async (track: IndexedTrack, to: number) => {
        console.log({track,to})
        // to represente la position finale dans le tableau si elle est > a la position initiale
        // il faut tenir compte du fait qu'il faudra retirer le l'élément avant de le replacer dans le tableau
        // final donc décrémenter la valeur de to
        if(to>track.index) { to-- }
        const newTracks = arrayMove(tracks, track.index, to).map((tr, i) => ({ ...tr, index: i }))
        setTracks(newTracks)
        // pushHistory(userId!, playlistId!, name, newTracks)
        
        await setPlaylist(userId!, playlistId!, name, newTracks)

        if (mmePlayerRef.current && playlistId) {
            mmePlayerRef.current.loadPlaylist(cleanPlaylistId(playlistId))
        }
    }

    const addTrack = async (track: Track, index?: number) => {
        if (!index) {
            const newTracks = [ ...tracks, {
                ...track,
                uid: Math.random().toString(36).substr(2, 9),
                index: tracks.length
            }]
            setTracks(newTracks)
            // setPlaylist(userId!, playlistId!, name, newTracks)
            // pushHistory(userId!, playlistId!, name, newTracks)
            await setPlaylist(userId!, playlistId!, name, newTracks)
            if (mmePlayerRef.current && playlistId) {
                mmePlayerRef.current.loadPlaylist(cleanPlaylistId(playlistId))
            }
            return
        }

        const newTracks = [
            ...tracks.slice(0, index),
            {...track, uid: Math.random().toString(36).substr(2, 9)},
            ...tracks.slice(index),
        ].map((tr, i) => ({ ...tr, index: i }))
        setTracks(newTracks)
        // setPlaylist(userId!, playlistId!, name, newTracks)
        // pushHistory(userId!, playlistId!, name, newTracks)
        await setPlaylist(userId!, playlistId!, name, newTracks)
        if (mmePlayerRef.current && playlistId) {
            mmePlayerRef.current.loadPlaylist(cleanPlaylistId(playlistId))
        }
    }

    const delTrack = async (track: IndexedTrack) => {

        const index = tracks.findIndex((tr)=>{return (tr.uid === track.uid)})

        const newTracks = [
            ...tracks.slice(0, index),
            ...tracks.slice(index + 1),
        ].map((tr, i) => ({ ...tr, index: i }))
        setTracks(newTracks)
        await setPlaylist(userId!, playlistId!, name, newTracks)
        if (mmePlayerRef.current && playlistId) {
            mmePlayerRef.current.loadPlaylist(cleanPlaylistId(playlistId))
        }
        // pushHistory(userId!, playlistId!, name, newTracks)
    }

    const [openDialog, setOpenDialog] = useState(null as {
        title: string,
        message: string,
        callback: ()=>void,
    } | null)
    // const [openDialogResult, setOpenDialogResult] = useState(false)
    function openYesOrNo(title: string, message: string, callback: ()=>void) {
        setOpenDialog({
            title,
            message,
            callback,
        })
    }

    function closeYesOrNo(yesOrNo: boolean) {
        setOpenDialog(null)
        // setOpenDialogResult(yesOrNo)
    }

    // const [openIframe, setOpenIframe] = useState(null as string | null)

    if (name === '')
        return null

    return <Paper style={{
            display: 'flex',
            flexFlow: 'column',
            alignItems: 'start',
            width: '100%',
            height: '100%',
            // maxheight: '100%',
            padding: 16,
            boxSizing: 'border-box',
        }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {isOwner ? null : <LockIcon style={{ marginRight: 8 }} />}
            <Typography variant='h5' align='left'>
                {name}
            </Typography>
        </div>
        <Typography variant='caption' paragraph>
            {tracks.length} track{tracks.length > 1 ? 's' : ''} - {formatDuration(tracks
                .map(tr => tr.duration)
                .reduce((t1, t2) => t1 + t2, 0))}
        </Typography>
        <div style={{ display: 'flex', flexFlow: 'row' }}>
            <Button onClick={() => setOpenRenameDialog(true)} disabled={!isOwner}>
                Renommer
            </Button>
            <Button onClick={() => {
                openYesOrNo('Supprimer la playlist',
                    'Êtes-vous sur de vouloir supprimer cette playlist ?', onRemovePlaylist)
            }} disabled={!isOwner}>
                Supprimer
            </Button>
            <Button onClick={() => {
                const pid = playlistId && playlistId.split('-').length > 1
                    ? playlistId.split('-')[1]
                    : playlistId
                let url = `/pub/medianum.html#o=vertical&width=300&height=175&apikey=${settings.partner_key}&partnerid=${settings.partner_id}&partnername=${settings.partner_name}&context=medianum&playlist=${pid}`
                if (window.location.hostname === 'localhost') {
                    url = REACT_APP_EXPORT_PLAYLIST_URL + url
                }
                // if ('clipboard' in navigator) {
                //     (navigator as any).clipboard.writeText(url)
                // }

                var w = Math.min(1000, window.screen.width)
                var h = Math.min(720, window.screen.height)

                window.open(url, '_blank', 'width=' + w + ',height' + h)
                // openYesOrNo('Exporter cette playlist', url, ()=>{})

                // setOpenIframe(url)
            }}>
                Exporter
            </Button>
        </div>
        {
            !!playlistId ? <mme-player
                ref={mmePlayerRef}
                style={{
                    width: '100%',
                    // height: '600px',
                    marginTop: '16px',
                    marginBottom: '32px',
                }}
                apikey={settings.partner_key}
                partnerid={settings.partner_id}
                partnername={settings.partner_name}
                context='medianum'
                playlist={cleanPlaylistId(playlistId)}
            /> : null
        }
        <div style={{ display: 'flex', flexFlow: 'row' }}>
        {/* onClick={() => {
            popHistory(userId!, playlistId!, name)
        }} */}
        {/* <UndoIcon style={{ padding: 8 }} />
        <RedoIcon style={{ padding: 8 }} onClick={() => {            
        }} /> */}
        </div>
        <div style={{ width: '100%', maxHeight: '100%', overflowY: 'hidden' }}>
            <Flipper flipKey={tracks.sort(tr => tr.index).map(tr => tr.uid).join('-')}>
            {
                tracks
                .sort(tr => tr.index)
                .map((tr, i) => <Flipped key={tr.uid} flipId={tr.uid}>{flippedProps => <TrackItem
                    flippedProps={flippedProps}
                    key={tr.uid}
                    track={tr}
                    isOwner={isOwner}
                    moveTrack={(tr) => moveTrack(tr, i)}
                    addTrack={addTrack}
                    delTrack={delTrack}
                    onClick={() => {
                        const idx = tracks.findIndex((t)=>{return (tr.uid === t.uid)})
                        // setCurrentTrack(idx)
                        const player = document.getElementsByTagName('mme-player') as HTMLCollectionOf<MMEEmbeddedPlayer>
                        if (player.length >= 1) {
                            console.log('players', player)
                            console.log('players[0]', player[0])
                            player[0].play(idx)
                        }
                    }}
                />}</Flipped>)
            }
            </Flipper>
        </div>
        { isOwner ? <EmptyDropZone addTrack={addTrack} /> : null }
        <RenamePlaylistDialog open={openRenameDialog} onClose={() => {
            setOpenRenameDialog(false)
        }} onValid={name => {
            setName(name)
            onRenamePlaylist(name)
        }} oldName={name} />
        <YesOrNo open={!!openDialog}
            title={!!openDialog ? openDialog.title : ''}
            message={!!openDialog ? openDialog.message : ''}
            callback={!!openDialog ? openDialog.callback : ()=>{}}
            onClose={closeYesOrNo} />
        {/* <IframeDialog
            src={openIframe}
            open={!!openIframe}
            onClose={() => setOpenIframe(null)} /> */}
    </Paper>
}

export default memo(MedialistManager)

function RenamePlaylistDialog({ open, onClose, onValid, oldName }: {
    oldName: string,
    open: boolean,
    onClose: ()=>void,
    onValid: (name: string)=>void,
  }) {
    const [name, setName] = useState(oldName)
  
    return <Dialog open={open} onClose={() => {
        setName('')
        onClose()
    }}>
      <DialogTitle>Renommer la playlist</DialogTitle>
      <DialogContent>
        {/* <DialogContentText>
        </DialogContentText> */}
        <TextField
          autoFocus
          margin='dense'
          label='Nom de la playlist'
          fullWidth
          value={name}
          onChange={(evt) => setName(evt.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={onClose}>Annuler</Button>
        <Button color='primary' onClick={() => {
            onValid(name)
            setName('')
            onClose()
        }}>Renommer</Button>
      </DialogActions>
    </Dialog>
  }

function YesOrNo({ title, message, open, onClose, callback }: {
    open: boolean,
    title: string,
    message: string,
    onClose: (yesOrNo: boolean)=>void,
    callback: ()=>void,
}) {
    return <Dialog open={open} onClose={() => onClose(false)}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <DialogContentText>
                {message}
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button color='primary' onClick={() => {
                callback()
                onClose(true)
            }}>Ok</Button>
            <Button color='primary' onClick={() => onClose(false)}>Annuler</Button>
        </DialogActions>
    </Dialog>
}

// function IframeDialog({ src, open, onClose }: {
//     src: string | null,
//     open: boolean,
//     onClose: ()=>void,
// }) {
//     return <Dialog open={!!src} fullScreen={true} onClose={onClose}>
//         <DialogContent>
//             <iframe src={src!} height={800} style={{
//                 minWidth: '100%',
//                 minHeight: '100%',
//                 border: 'none',
//                 margin: 0,
//             }} />
//         </DialogContent>
//     </Dialog>
// }